'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitPartnerForm = exports.submitAcademyForm = exports.submitEmployeeForm = exports.submitPortalId = exports.submitSignupForm = undefined;

var _FORMS_BY_PRODUCT, _CODE_FUNNEL_PRODUCTS, _TRIAL_ID_TO_NAME;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _immutable = require('immutable');

var _map = require('hs-lodash/map');

var _map2 = _interopRequireDefault(_map);

var _without = require('hs-lodash/without');

var _without2 = _interopRequireDefault(_without);

var _HubspotFormSubmissionDAO = require('../data/HubspotFormSubmissionDAO');

var _QueryParamsContainer = require('../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _signupProducts = require('../constants/signupProducts');

var _signupProducts2 = _interopRequireDefault(_signupProducts);

var _defaultUtms = require('../constants/defaultUtms');

var _defaultUtms2 = _interopRequireDefault(_defaultUtms);

var _AppConfigContainer = require('../globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

var _isExternalLink = require('../utils/isExternalLink');

var _isExternalLink2 = _interopRequireDefault(_isExternalLink);

var _UserCookies = require('../utils/UserCookies');

var _formIds = require('../constants/formIds');

var _Raven = require('Raven');

var _Raven2 = _interopRequireDefault(_Raven);

var _deviceUtils = require('../utils/deviceUtils');

var _apiClient = require('../utils/http/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _GetGdprSubmissionText = require('../utils/GetGdprSubmissionText');

var _GetGdprSubmissionText2 = _interopRequireDefault(_GetGdprSubmissionText);

var _AnalyticsActions = require('./AnalyticsActions');

var _LocaleActions = require('./LocaleActions');

var _Partner = require('../selectors/Partner');

var _isFunnel = require('../utils/isFunnel');

var _isFunnel2 = _interopRequireDefault(_isFunnel);

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LOG = _Logger2.default.getLogger('HubspotFormSubmissionActions');

// This needs to be moved to a more top-level place.
// It isn't scalable to keep adding endpoints here.
var FORMS_BY_PRODUCT = (_FORMS_BY_PRODUCT = {}, _defineProperty(_FORMS_BY_PRODUCT, _signupProducts2.default.MARKETING_FREE, _formIds.LEADIN_SIGNUP_FORM_ID), _defineProperty(_FORMS_BY_PRODUCT, _signupProducts2.default.CRM, _formIds.CRM_SIGNUP_FORM_ID), _defineProperty(_FORMS_BY_PRODUCT, _signupProducts2.default.SALES_FREE, _formIds.SALES_SIGNUP_FORM_ID), _defineProperty(_FORMS_BY_PRODUCT, _signupProducts2.default.ACADEMY, _formIds.ACADEMY_SIGNUP_FORM_IDS), _defineProperty(_FORMS_BY_PRODUCT, _signupProducts2.default.SERVICE, _formIds.SERVICE_SIGNUP_FORM_ID), _defineProperty(_FORMS_BY_PRODUCT, _signupProducts2.default.HUBSPOT_FOR_STARTUPS, _formIds.FOR_STARTUPS_APPLICATION_FORM_ID), _defineProperty(_FORMS_BY_PRODUCT, _signupProducts2.default.PARTNER_CLIENT_SIGNUP, _formIds.PARTNER_CLIENT_SIGNUP), _defineProperty(_FORMS_BY_PRODUCT, _signupProducts2.default.SALES_PARTNER, _formIds.SALES_PARTNER_SIGNUP), _defineProperty(_FORMS_BY_PRODUCT, _signupProducts2.default.DIRECTORY_USER, _formIds.DIRECTORY_USER_SIGNUP), _defineProperty(_FORMS_BY_PRODUCT, _signupProducts2.default.TRIAL, _formIds.TRIAL_SIGNUP_FORM_ID), _defineProperty(_FORMS_BY_PRODUCT, _signupProducts2.default.MARKETING_TRIAL, _formIds.TRIAL_SIGNUP_FORM_ID), _FORMS_BY_PRODUCT);

var CODE_FUNNEL_PRODUCTS = (_CODE_FUNNEL_PRODUCTS = {}, _defineProperty(_CODE_FUNNEL_PRODUCTS, _signupProducts2.default.MARKETING_FREE, 'Marketing-Free'), _defineProperty(_CODE_FUNNEL_PRODUCTS, _signupProducts2.default.CRM, 'Sales-CRM'), _defineProperty(_CODE_FUNNEL_PRODUCTS, _signupProducts2.default.SALES_FREE, 'Sales-Free'), _CODE_FUNNEL_PRODUCTS);

var TRIAL_ID_TO_NAME = (_TRIAL_ID_TO_NAME = {}, _defineProperty(_TRIAL_ID_TO_NAME, 1, 'Sales Hub Enterprise'), _defineProperty(_TRIAL_ID_TO_NAME, 2, 'Marketing Hub Enterprise'), _defineProperty(_TRIAL_ID_TO_NAME, 3, 'Service Hub Enterprise'), _defineProperty(_TRIAL_ID_TO_NAME, 4, 'Marketing Hub Professional'), _defineProperty(_TRIAL_ID_TO_NAME, 5, 'Reporting Add-On'), _defineProperty(_TRIAL_ID_TO_NAME, 7, 'HubSpot CMS'), _defineProperty(_TRIAL_ID_TO_NAME, 8, 'Sales Hub Professional'), _defineProperty(_TRIAL_ID_TO_NAME, 9, 'Service Hub Professional'), _TRIAL_ID_TO_NAME);

var ACADEMY_SURVEY_SUBMISSION_URI = 'academy/v1/signup';

function buildField(fieldValue, fieldKey) {
  return fieldValue ? { name: fieldKey, value: fieldValue } : null;
}

var getFormId = function getFormId(signupProduct) {
  var formIdOrIdMap = FORMS_BY_PRODUCT[signupProduct];
  var formId = formIdOrIdMap;
  if (formIdOrIdMap instanceof Object) {
    formId = formIdOrIdMap[_I18n2.default.locale] || formIdOrIdMap[_I18n2.default.defaultLocale];
  }
  return formId;
};

var submitSignupForm = exports.submitSignupForm = function submitSignupForm(email, website, firstname, lastname, company, intent, partnerRequestState, partnerCompany, partnerPrivacyLink) {
  return function (dispatch, getState) {
    var signupProduct = _AppConfigContainer2.default.get('signupProduct');
    var formId = getFormId(signupProduct);

    if (!formId) {
      return;
    }

    // remove default utms from this list, leaving only prefixed.
    var filteredParams = _QueryParamsContainer2.default.get().filter(function (value, param) {
      return _defaultUtms2.default.indexOf(param) === -1;
    });

    var fields = (0, _without2.default)((0, _map2.default)({
      firstname: firstname,
      lastname: lastname,
      email: email,
      website: website,
      company: company,
      terms_of_service_agreement: true
    }, buildField), null);

    if (_isFunnel2.default.crm()) {
      var websiteField = fields.find(function (o) {
        return o.name === 'website';
      });
      if (!websiteField) {
        LOG.warn('No website field on form submission', { extra: { formId: formId } });
        (0, _AnalyticsActions.trackEvent)('interaction', { action: 'form-submission-website-no-field' });
      } else if (!websiteField.value) {
        LOG.warn('No website field (value) on form submission', { extra: { formId: formId } });
        (0, _AnalyticsActions.trackEvent)('interaction', { action: 'form-submission-website-no-value' });
      } else {
        (0, _AnalyticsActions.trackEvent)('interaction', {
          action: 'form-submission-website-value-set'
        });
      }
    }

    if (intent && signupProduct === _signupProducts2.default.ACADEMY && (0, _isExternalLink2.default)(intent)) {
      fields.push(buildField('Academy-Content', 'product_signup'));
    }

    if (signupProduct && signupProduct === _signupProducts2.default.TRIAL) {
      var trialId = _QueryParamsContainer2.default.get('trialId');
      var utmSource = _QueryParamsContainer2.default.get('utm_source');
      var trialName = TRIAL_ID_TO_NAME[trialId];
      var trialSource = utmSource ? 'website-' + utmSource : 'website-trial-signup';
      fields.push(buildField(trialName, 'recent_in_app_trial_product'));
      fields.push(buildField(trialSource, 'trial_source'));
    }

    // add portal_language to all submissions
    var locale = _I18n2.default.locale || _I18n2.default.defaultLocale;
    var langCode = locale.split('-')[0];
    var language = _LocaleActions.LANG_CODE_TO_FULL_NAME[langCode];
    if (language) {
      fields.push(buildField(language, 'portal_language'));
    }

    var state = getState();

    var submissionText = (0, _GetGdprSubmissionText2.default)(partnerRequestState, partnerPrivacyLink, partnerCompany, (0, _Partner.getPartnerId)(state));

    if (!submissionText) {
      submissionText = '-';
      LOG.error('No gdpr submission text');
    }

    // subscription ID = 16: Default Subscription Type for Signup. Category: Marketing, Channel: Email. Name: Education, Content & Resources
    var legalConsentOptions = {
      legitimateInterest: {
        value: true,
        text: submissionText,
        subscriptionTypeId: 16,
        legalBasis: 'CUSTOMER'
      }
    };

    var utk = (0, _UserCookies.getUtk)();

    if (utk) {
      var context = {
        hutk: utk,
        pageUri: 'http://app.hubspot.com/signup/',
        pageName: 'Hubspot Signup Form'
      };
    }

    var skipValidation = true;
    var userData = { fields: fields, legalConsentOptions: legalConsentOptions, context: context, skipValidation: skipValidation };

    var _getState = getState(),
        utms = _getState.utms;

    var formData = filteredParams.merge(utms.get('filtered'), userData);

    (0, _HubspotFormSubmissionDAO.submitForm)({
      portalId: '53',
      formId: formId,
      data: formData
    });
  };
};

var submitAdditionalInfo = function submitAdditionalInfo(fields) {
  var signupProduct = _AppConfigContainer2.default.get('signupProduct');
  var formId = getFormId(signupProduct);

  if (!formId) {
    return;
  }

  return (0, _HubspotFormSubmissionDAO.submitForm)({
    portalId: '53',
    formId: formId,
    data: (0, _immutable.Map)(Object.assign({}, { fields: fields, skipValidation: true }))
  });
};

var submitPortalId = exports.submitPortalId = function submitPortalId(_ref) {
  var email = _ref.email,
      portalId = _ref.portalId;

  var fields = (0, _map2.default)({
    email: email,
    crm_hub_id: portalId
  }, buildField);

  submitAdditionalInfo(fields);
};

var submitEmployeeForm = exports.submitEmployeeForm = function submitEmployeeForm(_ref2) {
  var email = _ref2.email,
      companySizeLabel = _ref2.companySizeLabel,
      jobField = _ref2.jobField,
      jobRole = _ref2.jobRole,
      crmExperience = _ref2.crmExperience;

  var fields = (0, _without2.default)((0, _map2.default)({
    email: email,
    product: _AppConfigContainer2.default.get('setupProductName'),
    employees__c: companySizeLabel,
    survey_job_field: jobField,
    sales_signup_job_role: jobRole,
    crm_experience: crmExperience,
    sign_up_device: (0, _deviceUtils.getDevicePlatform)()
  }, buildField), null);

  return submitAdditionalInfo(fields);
};

function postAcademyAdditionalInfo(surveyData) {
  return _apiClient2.default.post(ACADEMY_SURVEY_SUBMISSION_URI, { data: surveyData });
}

var submitAcademyForm = exports.submitAcademyForm = function submitAcademyForm(_ref3) {
  var email = _ref3.email,
      surveyData = _ref3.surveyData;

  try {
    var fields = {
      email: email,
      locale: _I18n2.default.locale || _I18n2.default.defaultLocale,
      isAgency: surveyData.isAgency,
      companySize: surveyData.companySize
    };

    return postAcademyAdditionalInfo(fields);
  } catch (e) {
    LOG.error('Error submitting Academy form', { extra: { error: e } });
  }
};

var submitPartnerForm = exports.submitPartnerForm = function submitPartnerForm() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState) {
    var filteredParams = _QueryParamsContainer2.default.get().filter(function (value, param) {
      return _defaultUtms2.default.indexOf(param) === -1;
    });

    var utk = (0, _UserCookies.getUtk)();
    var context = void 0;

    if (utk) {
      context = {
        hutk: utk,
        pageUri: 'http://app.hubspot.com/signup/',
        pageName: 'Hubspot Signup Form'
      };
    }

    var fields = Object.keys(data).map(function (key) {
      return {
        name: key,
        value: data[key]
      };
    });
    var skipValidation = true;
    var userData = { fields: fields, context: context, skipValidation: skipValidation };

    var _getState2 = getState(),
        utms = _getState2.utms;

    var formData = filteredParams.merge(utms.get('filtered'), userData);

    (0, _HubspotFormSubmissionDAO.submitForm)({
      portalId: '53',
      formId: '4c8f0e7f-327a-44cb-9bff-e0214b207a14',
      data: formData
    });
  };
};